import type { IntlShape } from 'react-intl'

export function getSkyLoungeLabel(intl: IntlShape): string {
  return intl.formatMessage({
    id: 'fN4V5nna5n-IMrrm374s',
    defaultMessage: 'SkyLounge',
    description: 'Shared label for the SkyLounge cabin and seat option shown throughout the flights experience',
  })
}

export function getIllustrativePurposesOnlyLabel(intl: IntlShape): string {
  return intl.formatMessage({
    id: 'kVEBo4WZee0940CUmUSj',
    defaultMessage: 'Illustrative purposes only',
    description: 'Shared disclaimer shown below flights images to indicate the visuals are illustrative only',
  })
}
